import React from 'react'
import {useIntl} from 'react-intl'
import styled from '@emotion/styled'
import {Summary} from '@findhotel/sapi/dist/types/packages/core/src/insights'

import {Box} from '@vio/atlas/helpers/Box'
import {ButtonLink} from '@vio/atlas/src/components/designSystem/ButtonLink'
import {Icon} from '@vio/atlas/src/components/designSystem/Icon'
import {Text} from '@vio/atlas/Text'

import {getCategoryIcon, getCategoryTitle} from '../utils'

const StyledButtonLink = styled(ButtonLink)`
  padding: 0;
`

interface Props {
  details: Summary
  hasPadding?: boolean
  onCategoryClick: () => void
}
export const AiPoweredReviewsCategoryCard: React.FC<Props> = ({
  details,
  hasPadding,
  onCategoryClick
}) => {
  const {formatMessage} = useIntl()

  return (
    <Box
      data-id="ai-powered-review-category-card"
      onClick={onCategoryClick}
      backgroundColor="background.brand.tertiary"
      borderRadius="md"
      padding={hasPadding ? 's400' : 's000'}
      minWidth="160px"
      desktopMd={{minWidth: 'auto'}}
    >
      <Box marginBottom="s300">
        <Icon
          name={getCategoryIcon(details.category)}
          size="lg"
          colorPath="tag.neutral.content"
        />
      </Box>
      <Text variant="bodyM">
        {formatMessage(getCategoryTitle(details.category))}
      </Text>
      <StyledButtonLink size="sm">{details.title}</StyledButtonLink>
    </Box>
  )
}
